export const FellowsList = [
    {
        "name": "Kathy Lachman",
        "subjects": "BIOS 201/301/302/353, CHEM 121/122/211/320",
        "email": "kl116@rice.edu"
    },
    {
        "name": "Nyla Hartigan",
        "subjects": "PHYS 111/112, MATH 211/212, any EEPS",
        "email": "nrh1@rice.edu"
    },
    {
        "name": "Samvita Gautham",
        "subjects": "BIOS 300/301, CHEM 121/122, SPAN 330/368, PHYS 125, MDHM 201/268, ENGL 200/330",
        "email": "sg185@rice.edu"
    },
    {
        "name": "Varsha Chandramouli",
        "subjects": "CHEM 211/313, BIOS 372/301/334, MATH 212, KINE 301/300/351/302",
        "email": "vkc1@rice.edu"
    },
    {
        "name": "Mira Srinivasa",
        "subjects": "CHEM 211/313, BIOS 341, BIOE 252/322/391/332/372/370",
        "email": "mas50@rice.edu"
    },
    {
        "name": "Sean McGarry",
        "subjects": "Any STAT, low level SMGT & BUSINESS",
        "email": "spm10@rice.edu"
    },
    {
        "name": "Arcadia Hinton-Cooley",
        "subjects": "Writing, SOSC 302, PSYC 101/202/203/340",
        "email": "arh8@rice.edu"
    },
    {
        "name": "Zack Donovan",
        "subjects": "CMOR 220/302/304/360, MATH 101/102/212/221/212/222/270/302/321/354/355",
        "email": "zd25@rice.edu"
    },
    {
        "name": "Anjali Mathew",
        "subjects": "COMP 140, ECON 100, COMP 182, ECON 200/203, COMP 215/312",
        "email": "am307@rice.edu"
    },
    {
        "name": "Ben Lindenbaum",
        "subjects": "COMP 140/182/215/312",
        "email": "bl77@rice.edu"
    },
    {
        "name": "Biraj Nainabasti",
        "subjects": "BIOS 201/202/301, CHEM 211, PHYS 126",
        "email": "bn25@rice.edu"
    },
    {
        "name": "Melissa Lee",
        "subjects": "BIOS 202, KINE 300/301/310/311/319/321/440, HEAL 103",
        "email": "mcl15@rice.edu"
    },
    {
        "name": "Jackson O'Brian",
        "subjects": "MECH 202/310, CHEM 121/211, CMOR 220, MATH 211",
        "email": "jo60@rice.edu"
    },
    {
        "name": "Coleman O'Brian",
        "subjects": "MECH 202/200, CMOR 220, MATH 212/211",
        "email": "co63@rice.edu"
    },
    {
        "name": "Leslie Rojo Flores",
        "subjects": "PSYC 101/203/202, SOCI 101, FWIS, Spanish all levels, CMOR 220",
        "email": "lr80@rice.edu"
    },
    {
        "name": "Rebecca Tang",
        "subjects": "CHEM 211, PSYC 202, FWIS/writing, STAT 310, ASIA 216",
        "email": "rt66@rice.edu"
    },
    {
        "name": "Simran Ghosh",
        "subjects": "STAT 410, ECON 307/455, Creative/fiction writing",
        "email": "sg256@rice.edu"
    },
    {
        "name": "Ankita Rajesh",
        "subjects": "ECON 100, DSCI 101, CHEM 211",
        "email": "ar228@rice.edu"
    },
    {
        "name": "Gwendolyn Crain",
        "subjects": "English, Poli Sci, Writing",
        "email": "gc63@rice.edu"
    },
    {
        "name": "Tori Cole",
        "subjects": "POLI 211, POLI 210, Writing/FWIS",
        "email": "tmc16@rice.edu"
    },
    {
        "name": "Eshika Tandon",
        "subjects": "BIOS 201, BIOS 341, BIOS 385",
        "email": "et58@rice.edu"
    }
]